export function getBase64(file, cb) {
	const reader = new FileReader();
	reader.readAsDataURL(file);
	reader.addEventListener('load', () => {
		cb(reader.result);
	});

	reader.addEventListener('error', (error) => {
		console.log('Error:', error);
	});
}
